import { Services } from '@project/API';
import { action, makeObservable, observable, runInAction } from 'mobx';

export class CartogramFeaturesStore {
  private _services: Services;
  @observable data: GeoJSON.Feature[] = [];
  @observable isLoading: boolean = false;
  @observable error?: string = undefined;

  constructor(services: Services) {
    this._services = services;
    makeObservable(this);
  }

  @action load = async (tableName: string) => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await this._services.records.apiGeojsonList(
        tableName,
        1,
        0,
        {
          query: { _srid: 3857 },
        },
      );
      runInAction(() => {
        this.data = response.data.features;
      });
    } catch (e) {
      runInAction(() => {
        this.error = 'Произошла ошибка загрузки';
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  @action clear = () => {
    this.data = [];
  };
}
